import {StoppageInfo} from '@domain/stoppages'
import {AnalysisListPage, CreateAnalysisPage, AnalysisDetailPage} from '@features/rcfa-list'
import {StoppageList, StoppageNavigationProvider} from '@features/stoppage-list'
import {useCallback} from 'react'
import {ErrorBoundary} from 'react-error-boundary'
import {Outlet, useLocation, Navigate, useNavigate} from 'react-router'

import {useUrlParam} from '../shared/hooks/useUrlParam'

import {RcfaErrorFallback} from './container/RcfaErrorFallback'
import {TasksList} from './pages/TasksList'
import {REL_ROUTES, routes} from './routes'

const MaintainStoppageList = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const plantId = useUrlParam('plantId')

  const navigateToAnalysis = useCallback(
    async (stoppage: StoppageInfo) => {
      await navigate(`/plant/${plantId}/rcfa/graphDetail/${stoppage.analysisId}/graph`, {
        state: location
      })
    },
    [navigate, location, plantId]
  )

  const navigateToCreateAnalysis = useCallback(
    async (stoppage: StoppageInfo) => {
      await navigate(routes.newAnalysis.replace(':plantId', plantId) + '?type=stoppage', {
        state: {selectedStoppage: stoppage}
      })
    },
    [navigate, plantId]
  )

  return (
    <StoppageNavigationProvider
      navigateToAnalysis={navigateToAnalysis}
      navigateToCreateAnalysis={navigateToCreateAnalysis}
    >
      <StoppageList />
    </StoppageNavigationProvider>
  )
}

export const RcfaRoutes = [
  {
    path: REL_ROUTES.graphDetail,
    element: <AnalysisDetailPage />
  },
  {
    path: REL_ROUTES.newAnalysis,
    element: <CreateAnalysisPage />
  },
  {
    path: REL_ROUTES.analysisList,
    element: <AnalysisListPage />
  },
  {
    path: REL_ROUTES.tasksList,
    element: <TasksList />
  },
  {
    path: REL_ROUTES.stoppageList,
    element: <MaintainStoppageList />
  },
  {
    path: '*',
    element: <Navigate to={REL_ROUTES.analysisList} replace />
  }
]
export const RcfaApp = () => {
  const location = useLocation()
  return (
    <ErrorBoundary FallbackComponent={RcfaErrorFallback} resetKeys={[location.pathname]}>
      <Outlet />
    </ErrorBoundary>
  )
}
